import { DOCUMENT, inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private readonly doc: Document = inject(DOCUMENT);
  private readonly storage?: Storage = this.doc.defaultView?.localStorage;

  public set(key: string, value: string): void {
    this.storage?.setItem(key, value);
  }

  public get(key: string): string | null {
    return this.storage?.getItem(key) ?? null;
  }

  public remove(key: string): void {
    this.storage?.removeItem(key);
  }
}
